// 班次
export const scheduleTimeOptions = [
  {
    label: "早班",
    code: "BC0001",
    short: "早",
    color: "#8beb56",
    backgroundColor: "#ecfbe2",
  },
  {
    label: "晚班",
    code: "BC0002",
    short: "晚",
    color: "#70aaff",
    backgroundColor: "#e8f0ff",
  },
  {
    label: "外派",
    code: "BC0003",
    short: "外",
    color: "#58f2bb",
    backgroundColor: "#e4fcf3",
  },
  {
    label: "出差",
    code: "BC0004",
    short: "出",
    color: "#a688ff",
    backgroundColor: "#efe9ff",
  },
  {
    label: "请假",
    code: "BC0005",
    short: "假",
    color: "#ff7b79",
    backgroundColor: "#fde8e7",
  },
  {
    label: "休息",
    code: "BC0006",
    short: "休",
    color: "#ffb979",
    backgroundColor: "#fef3e7",
  },
  {
    label: "上午班",
    code: "BC0007",
    short: "上",
    color: "#9371ed",
    backgroundColor: "#d6c4ff",
  },
  {
    label: "下午班",
    code: "BC0008",
    short: "下",
    color: "#58e3ad",
    backgroundColor: "#c9ffe5",
  },
];

export const scheduleTimeInit = (data) => {
  const res = [];
  data.forEach((item) => {
    const find = scheduleTimeOptions.find(
      (row) => row.code === item.scheduleNo
    );
    if (find) {
      res.push({
        ...find,
        short: item.shortName || find.short,
        label: item.scheduleName,
        status: item.status,
        startTime: item.startTime,
        endTime: item.endTime,
        id: item.id,
      });
    }
  });
  return res;
};

// 日期设置
export const scheduleDatesGet = (list) => {
  return list.map((item) => {
    item.dates = scheduleDatesFormat(item.scheduleList);
    return item;
  });
};

export const scheduleDatesFormat = (list) => {
  const res = {};
  if (list) {
    for (let i = 0; i < list.length; i++) {
      res[list[i].date] = list[i];
    }
  }
  return res;
};

export const scheduleDatesSet = (data) => {
  const list = JSON.parse(JSON.stringify(data));
  for (let i = 0; i < list.length; i++) {
    list[i].scheduleList = scheduleDatesToList(list[i].dates);
    delete list[i].dates;
  }
  return list;
};

export const scheduleDatesToList = (dates) => {
  const res = [];
  for (let k in dates) {
    res.push(dates[k]);
  }
  return res;
};

// 数据设置
export const scheduleDatasSet = (dates, row, channelCode) => {
  const res = {};
  for (let i = 0; i < dates.length; i++) {
    const date = dates[i];
    res[date] = {
      scNo: row.code,
      date,
      startTime: row.startTime ? `${date} ${row.startTime}:00` : null,
      endTime: row.endTime ? `${date} ${row.endTime}:00` : null,
      channelCode,
    };
  }
  return res;
};
